import D2C_ServiceApp from './App'

class D2C_ServicePHPNginx extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = true
  static order = 10
  static typeName = 'phpNginx'
  static typeTitle = 'PHP + Nginx'
  static color = '#7777cc'
  static methods = {
    ...D2C_ServiceApp.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    configs: {
      ...D2C_ServiceApp.fields.configs,
      default: [
        {name: 'php.ini', text: require('raw-loader!@/assets/configs/phpNginx-php.ini').default, custom: false},
        {name: 'php-fpm.conf', text: require('raw-loader!@/assets/configs/phpNginx-php-fpm.conf').default, custom: false},
        {name: 'nginx.conf', text: require('raw-loader!@/assets/configs/phpNginx-nginx.conf').default, custom: false},
        {name: 'default.conf', text: require('raw-loader!@/assets/configs/phpNginx-default.conf').default, custom: false},
      ],
    },
    extensions: {
      default: ['mysqli', 'opcache', 'gd', 'zip'],
      enum: ['bcmath', 'bz2', 'calendar', 'dba', 'enchant', 'exif', 'gd', 'gettext', 'gmp', 'imap', 'interbase', 'intl', 'ldap', 'mysqli', 'opcache', 'pcntl', 'pdo_dblib', 'pdo_firebird', 'pdo_mysql', 'pdo_odbc', 'pdo_pgsql', 'pgsql', 'pspell', 'recode', 'shmop', 'snmp', 'soap', 'sockets', 'sysvmsg', 'sysvsem', 'sysvshm', 'tidy', 'wddx', 'xmlrpc', 'xsl', 'zip'],
      label: 'PHP extensions',
      multiple: true,
      path: 'extensions',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'd2cio/php-nginx',
    },
    peclPackages: {
      default: [],
      enum: ['amqp', 'apcu', 'ast', 'ds', 'event', 'geoip', 'grpc', 'igbinary', 'imagick', 'mcrypt', 'memcached', 'mongodb', 'oauth', 'rdkafka', 'redis', 'uuid', 'xdebug', 'yaml'],
      label: 'PECL Packages',
      multiple: true,
      path: 'peclPackages',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 80},
      ],
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/phpNginx-hello-world',
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '7.4',
      enum: ['7.2', '7.3', '7.4'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false},
      ],
    },
  }
}

export default D2C_ServicePHPNginx
